
import httpClient from "@/plugins/axios";

export const getUsers = async (page, pageSize, query) => {
    const response = await httpClient.get(`/admin/v1/users/?page=${page}&page_size=${pageSize}`,
        {
            params: {
                search: query
            }
        }
    );
    return response;
}

export const getNewUsers = async () => {
    const response = await httpClient.get(`/v1/users/new/`);
    return response;
}

export const getNotLoggedInUsers = async () => {
    const response = await httpClient.get(`/v1/users/notloggedin/`);
    return response;
}

export const getAdmins = async (page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const getUser = async (userId) => {
    const response = await httpClient.get(`/admin/v1/users/${userId}/`);
    return response;
}

export const getUserGroups = async (userId) => {
    const response = await httpClient.get(`/admin/v1/users/${userId}/groups/`);
    return response;
}

export const getUserAdminGroups = async (userId) => {
    const response = await httpClient.get(`/admin/v1/users/${userId}/admin-groups/`);
    return response;
}

export const searchUsers = async (query) => {
    const response = await httpClient.get(`/v1/people/search/?search=${encodeURIComponent(query)}&admin_view=1`);
    return response;
}

export const importUser = async (user) => {
    const response = await httpClient.post(`/v1/users/import/?admin_view=1`, user);
    return response;
}

export const saveUser = async (user) => {
    if (user.id) {
        const response = await updateUser(user);
        return response;
    }
    else {
        const response = await insertUser(user);
        return response;
    }
}

const insertUser = async (user) => {
    return await httpClient.post(`/admin/v1/users/`, user);
}

const updateUser = async (user) => {
    return await httpClient.put(`/admin/v1/users/${user.id}/`, user);
}

export const removeUser = async (userId) => {
    const response = await httpClient.delete(`/admin/v1/users/${userId}/`);
    return response;
}

export const updateUserImage = async (userId, imageBlob, imageName) => {
    const formData = new FormData();
    formData.append("image", imageBlob, imageName);

    const response = await httpClient.put(`/admin/v1/users/${userId}/image/`, formData);
    return response;
}

export const removeUserImage = async (userId) => {
    const response = await httpClient.put(`/admin/v1/users/${userId}/image/`,
        {
            remove_image: true
        });
    return response;
}

export const getTenantAdmins = async (page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

// Both tenant and group admins
export const getAllAdmins = async () => {
    const response = await httpClient.get(`/v1/tenant/all-admins/?page_size=50`);
    return response;
}

export const inviteUser = async (userId, message) => {
    const response = await httpClient.post(`/v1/users/invite/?admin_view=1`, {
        'id': userId,
        message
    });
    return response;
}

export const listMainUsers = async () => {
    const response = await httpClient.get(`/v1/mainusers/`);
    return response;
}

export const promoteMainUser = async (userId) => {
    const response = await httpClient.post(`/v1/mainusers/`, { user_id: userId });
    return response;
}

export const demoteMainUser = async (userId) => {
    const response = await httpClient.delete(`/v1/mainusers/${userId}/`);
    return response;
}

export const getMainUserLog = async (page = 1, pageSize = 20) => {
    const response = await httpClient.get(`/v1/mainusers/log/?page=${page}&page_size=${pageSize}`);
    return response;
}

